<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>

    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('customer.remoteUsers.username')}} </b-th>
            <b-th> {{$t('customer.remoteUsers.name')}} </b-th>
            <b-th> {{$t('customer.remoteUsers.lastname')}} </b-th>
            <b-th> {{$t('customer.remoteUsers.phone')}} </b-th>
            <b-th> {{$t('customer.remoteUsers.email')}} </b-th>
            <b-th> {{$t('customer.remoteUsers.status')}} </b-th>
            <b-th> {{$t('account.list.actions')}} </b-th>
        </b-thead>
        <b-tbody>
           <b-tr v-for="ru in remoteUsers" :key="ru.id">
                <b-td> {{ru.username}} </b-td>
                <b-td> {{ru.firstname}} </b-td>
                <b-td> {{ru.lastname}} </b-td>
                <b-td> {{ru.phoneno}} </b-td>
                <b-td> {{ru.email}} </b-td>

                <b-td> 
                    <div v-if="ru.active == true" > <b-icon icon="check" variant="success"></b-icon> <b-badge variant="success" > {{$t('account.active')}} </b-badge> </div>
                    <div v-else >  <b-icon icon="x" variant="danger" animation="throb"></b-icon>  <b-badge variant="danger" > {{$t('account.suspend')}} </b-badge> </div>            
                </b-td>
                <b-td> 
                    <b-dropdown variant="default">
                        <template slot="button-content"> <b-icon :title="field.label" icon="three-dots"  scale="1.25" shift-v="1.25" aria-hidden="true" /> </template>
                        <b-dropdown-item 
                            v-for="action in actions"
                            :key="action.key"
                            @click="actionEvent(action.key, item )"
                            :disabled="action.state == item['active'] || action.state == item['is_active']"> 
                            {{action.text}}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-td>

            </b-tr>
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "VacationForm",
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            openModal:function(name, data){
                this.modalType(true, 'Vacation',9)
                this.modalEvent(true, name, data)
            },
            moment: function(data){
                return moment(data).format('DD MMMM YYYY');
            },
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            vacations(){
                return this.$store.getters.getAccountVacations
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/RemoteUser.vue